export interface ActivityFilterFormValue {
  status: string;
  amountFrom: string;
  amountTo: string;
  dateRange: {
    startDate: Date | null;
    endDate: Date | null;
  };
}

export const DEFAULT_ACTIVITY_FILTER_FORM_VALUE: ActivityFilterFormValue = {
  status: '',
  amountFrom: '',
  amountTo: '',
  dateRange: {
    startDate: null,
    endDate: null
  }
};
